import {clearAllCookies} from '@/services/cookie/cookieService';
import * as pathService from '@/services/route/pathService';
import routerService from '@/services/route/routerService';
import storageService from '@/services/storage/storageService';
import urlUtils from '@/utils/urlUtils';

import authService from './auth/authService';

const getMarketCodeFromLocation = () => {
    try {
        const isAem = pathService.isAemPath();
        const MARKET_CODE_INDEX = isAem ? 3 : 1;
        const marketCode = urlUtils.getCurrentPathname().split('/')[MARKET_CODE_INDEX];

        return marketCode;
    } catch (e) {
        return undefined;
    }
};

const getMarketCode = () => {
    const marketCode = getMarketCodeFromLocation();

    return marketCode;
};

const validateAndInitiateMarketCode = () => {
    const marketCodeFromLocation = getMarketCodeFromLocation();
    const marketCodeFromStorage = storageService.getMarketCodeFromLocalStorage();
    const skipMarketCodeValidation =
        process.env.REACT_APP_ENV !== 'prod' && localStorage.getItem('skipMarketCodeValidation') === 'true';

    if (
        !skipMarketCodeValidation &&
        marketCodeFromStorage &&
        marketCodeFromLocation &&
        marketCodeFromStorage !== marketCodeFromLocation
    ) {
        clearAllCookies();
        authService.logout();
    }

    if (marketCodeFromLocation) {
        storageService.setMarketCodeToLocalStorage(marketCodeFromLocation);
        return true;
    }

    if (!marketCodeFromStorage) return false;

    // If there is no marketCode in url but it is presented in localStorage -> add it to url
    routerService.redirect(marketCodeFromStorage);
    return true;
};

export default {
    getMarketCodeFromLocation,
    getMarketCode,
    validateAndInitiateMarketCode,
};
